import { createFileRoute } from '@tanstack/react-router'
import { MemberDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import EditMemberDialog from '@/routes/_app/-dialogs/edit-member'

export const Route = createFileRoute('/@modal/members/$memberId')({
  params: idParams('memberId'),
  staticData: { slotScope: '/_app/teams/$teamId' },
  pendingComponent: MemberDialogPending,
  component: EditMemberSlot,
})

function EditMemberSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditMemberDialog memberId={Number(params.memberId)} {...slot} />
}
